module.exports = __webpack_public_path__ + "img/falske-mails-1.df03472f.png";